import type { PositionSlotSecondaryCompetencyItem } from 'domain/shared/positionSlot';

export const buildSecondaryCompetencyLabel = ({
  specializationLabel,
  technologyLabel,
  competencyLevel,
}: PositionSlotSecondaryCompetencyItem) =>
  [specializationLabel, technologyLabel, competencyLevel].filter(Boolean).join(' · ');
